// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/core-js/modules/_enum-bug-keys.js
// module id = 60
// module chunks = 1